import styled from 'styled-components';

export default styled.span`
  color: #df6747 !important;
`;
